import axios from 'axios'

export function getEvidenciaBaseUrl(ticket, esSolucion) {
  if (esSolucion) {
    return axios.defaults.baseURL + 'evidencia-tickets/'
  }
  if (ticket && (ticket.tipousuario || ticket.movil)) {
    return ticket.id_unidad_negocio == 1
      ? 'https://lmsinbi.club/evidencia-tickets/'
      : 'https://lmsfast.club/evidencia-tickets/'
  }
  return axios.defaults.baseURL + 'evidencia-tickets/'
}

export async function descargarEvidencia(ticket, foto, esSolucion) {
  const nombreArchivo = (foto || '').split('/').pop() || 'evidencia'
  const usaApiPrincipal = esSolucion || !(ticket && (ticket.tipousuario || ticket.movil))

  if (usaApiPrincipal) {
    try {
      const response = await axios.get(`tickets.descargar.evidencia/${nombreArchivo}`, { responseType: 'blob' })
      const blobUrl = URL.createObjectURL(response.data)
      const link = document.createElement('a')
      link.href = blobUrl
      link.download = nombreArchivo
      link.click()
      URL.revokeObjectURL(blobUrl)
      return
    } catch (e) {
      // continuar con descarga directa
    }
  }

  const url = getEvidenciaBaseUrl(ticket, esSolucion) + foto

  try {
    const response = await fetch(url)
    if (response.ok) {
      const blob = await response.blob()
      const blobUrl = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.download = nombreArchivo
      link.click()
      URL.revokeObjectURL(blobUrl)
      return
    }
  } catch (e) {
    // continuar con fallback
  }

  const link = document.createElement('a')
  link.href = url
  link.download = nombreArchivo
  link.target = '_blank'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
